import styled from 'styled-components';
import React from 'react';
import { Box, Link } from '@mui/material';

const LogoWrapper = styled(Box)(() => ({
    flex: 1,
    img: {
        maxWidth: '250px',
    },
}));

export const LogoWrapperQuotation = () => {
    return (
        <LogoWrapper>
            <Link href={'/quotation'}>
                <img src="/assets/MESTER_SZERELVENYOLT_logo_RGB.svg" />
            </Link>
        </LogoWrapper>
    );
};
